import React, { useEffect, useState } from 'react';

import usePartnersAndAffiliates from '../hooks/usePartnersAndAffiliates';
import { AffiliatePartner } from '../data_models/affiliatePartner';
import LoadingIndicator from '../components/common/LoadingIndicator';
import useCurrentUser from '../hooks/useCurrentUser';
import PartnerListComponent from '../components/partnersAndAffiliates/PartnerListComponent';
import { FilledButton, OutlinedButton } from '../components/common/Button';
import useRouting from '../hooks/useRouting';
import useGlobalLoading from '../hooks/useGlobalLoading';
import InfoBox from '../components/common/InfoBox';


const PartnersAndAffiliatesPage: React.FC = () => {
    const { fetchPartnersAndAffiliates } = usePartnersAndAffiliates();
    const { currentUser, currentUserType } = useCurrentUser();
    const { goToLoginFreelancers, goToSignupFreelancers } = useRouting();

    const [affiliatePartners, setAffiliatePartners] = useState<Partial<AffiliatePartner>[]>();


    // set page
    const [partnersPage, setPartnersPage] = useState(1);
    const [partnersLimit, setPartnersLimit] = useState(100);

    const { setLoading } = useGlobalLoading();


    useEffect(() => {
        setLoading(true);
        console.log('fetching partners and affiliates');
        fetchPartnersAndAffiliates(partnersPage, partnersLimit).then((affiliatePartners) => {
            setAffiliatePartners(affiliatePartners as Partial<AffiliatePartner>[]);
        }).finally(() => {
            setLoading(false);
        });
    }, [partnersPage, partnersLimit])

    return (
        <div className="max-w-7xl mx-auto p-4">
            <div>
                {/* Sign up call to action */}
                {!currentUser &&

                    <InfoBox>
                        <h3 className='font-bold'>Not yet a Member?</h3>
                        <p>Find gigs as a talent or let us manage talent for you to get your projects done</p>
                        <div className='mt-6 flex space-x-2'>
                            <OutlinedButton onClick={goToLoginFreelancers}>Login</OutlinedButton>
                            <FilledButton onClick={goToSignupFreelancers}>Sign Up for Free</FilledButton>
                        </div>
                    </InfoBox>


                }

                {/* List of Partners */}
                <div className='flex flex-col space-y-4'>
                    <div>
                        <h1 className='font-bold mt-20'>Our Partners and Benefits</h1>
                    </div>
                    {affiliatePartners?.map((affiliatePartner: Partial<AffiliatePartner>) => (
                        <div key={affiliatePartner._id}>
                            <PartnerListComponent affiliatePartner={affiliatePartner} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PartnersAndAffiliatesPage;
